<!-- Ladeindikator -->
<div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
        <cds-progress-circle size="xl" status="info"></cds-progress-circle>
        <p>Daten werden geladen …</p>
    </div>
</div>

<div class="statistics-overview" *ngIf="statistics">
    <div class="statistic-item">
        <span class="statistic-label">Voxtral-Transkriptionen</span>
        <span class="statistic-value">{{ statistics.transcribedCount }}</span>
    </div>
    <div class="statistic-item">
        <span class="statistic-label">Davon an FAB gesendet</span>
        <span class="statistic-value">{{ statistics.fabCount }}</span>
    </div>
    <div class="statistic-item">
        <span class="statistic-label">Segmente gesamt</span>
        <span class="statistic-value">{{ statistics.segmentsTotal | number }}</span>
    </div>
    <div class="statistic-item">
        <span class="statistic-label">Ø Segmente pro Sendung</span>
        <span class="statistic-value">{{ statistics.segmentsAverage | number: '1.0-0' }}</span>
    </div>
    <div class="statistic-item">
        <span class="statistic-label">Ohne Export / 0 Segmente</span>
        <span class="statistic-value">{{ statistics.withoutExportCount }}</span>
    </div>
    <div class="statistic-item">
        <span class="statistic-label">Geplant, nie gestartet</span>
        <span class="statistic-value">{{ statistics.scheduledNeverRanCount }}</span>
    </div>
</div>

<clr-datagrid *ngIf="statistics" [clrDgLoading]="false" [clrDgColumnResize]="false">
    <clr-dg-column class="fixed-column">Datum</clr-dg-column>
    <clr-dg-column class="fixed-column">Sender</clr-dg-column>
    <clr-dg-column clrDgField="title">Titel der Sendung</clr-dg-column>
    <clr-dg-column class="fixed-column">FAB</clr-dg-column>
    <clr-dg-column class="key-column col-fab-url">FAB-URL</clr-dg-column>
    <clr-dg-column class="fixed-column">Segmente</clr-dg-column>
    <clr-dg-column class="fixed-column">Session-Start</clr-dg-column>
    <clr-dg-column class="status-column">Status</clr-dg-column>
    <clr-dg-column class="key-column col-transcript">Transkript</clr-dg-column>
    <clr-dg-column class="action-column">&nbsp;</clr-dg-column>

    <clr-dg-row *clrDgItems="let broadcast of broadcastList()" [clrDgItem]="broadcast">
        <clr-dg-cell class="text-cell fixed-column">
            {{ broadcast.programmDate }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell fixed-column">
            {{ broadcast.channel }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell ellipsis" [title]="broadcast.title">
            {{ broadcast.title }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell fixed-column">
            <cds-icon *ngIf="broadcast.sentToFab" shape="check" class="fab-yes" title="An FAB gesendet"></cds-icon>
            <span *ngIf="!broadcast.sentToFab" class="fab-no" title="FAB deaktiviert">–</span>
        </clr-dg-cell>
        <clr-dg-cell class="text-cell key-column col-fab-url ellipsis" [title]="displayFabUrl(broadcast)">
            {{ displayFabUrl(broadcast) }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell fixed-column">
            {{ broadcast.segmentsCount | number }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell fixed-column">
            {{ broadcast.sessionStartedAt ? (broadcast.sessionStartedAt | date: 'HH:mm') : '' }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell status-column">
            <span class="label" [ngClass]="statusClass(broadcast)">{{ statusLabel(broadcast) }}</span>
        </clr-dg-cell>
        <clr-dg-cell class="text-cell key-column col-transcript ellipsis" [title]="broadcast.transcriptS3Url">
            {{ broadcast.transcriptS3Url }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell action-column">
            <button class="btn btn-sm btn-link details-btn" type="button"
                    [disabled]="!broadcast.ran"
                    (click)="openDetails(broadcast)"
                    title="Segmente und Korrekturen dieser Session ansehen">
                <cds-icon shape="eye"></cds-icon>
            </button>
        </clr-dg-cell>
    </clr-dg-row>

    <clr-dg-footer>
        <div class="statistics-footer">
            <button class="btn btn-sm btn-primary" (click)="exportToCsv()">
                <cds-icon shape="download" solid></cds-icon>
                Exportieren
            </button>
            <span>{{ broadcastList().length }} Sendungen</span>
        </div>
    </clr-dg-footer>
</clr-datagrid>

<!-- Detail-Overlay: bestehende Export-Review-Komponente, laedt den Segment-
     Export der Session ueber /broadcast/voxtral-segments-export -->
<app-overlay-panel *ngIf="selectedBroadcast" mode="center" size="xl"
                   ariaLabel="Voxtral-Session ansehen" (closed)="closeDetails()">
    <span overlay-title>
      <span class="op-title-main">{{ selectedBroadcast.title }}</span>
      <span class="op-title-sub">{{ selectedBroadcast.programmDate }} · {{ selectedBroadcast.channel }}</span>
    </span>
    <app-voxtral-export-review [broadcastKey]="selectedBroadcast.key"></app-voxtral-export-review>
</app-overlay-panel>
